/*
 * @Author: 🐝
 * @Date: 2023-09-11 14:49:14
 * @LastEditors: Ant🐜
 * @LastEditTime: 2024-07-11 14:42:14
 * @Description: 描述一下
 */
export function resultSuccess(data, { message = 'ok' } = {}) {
  return {
    code: 0,
    data,
    message,
    type: 'success'
  }
}

export function resultPageSuccess(page, pageSize, list, { message = 'ok' } = {}) {
  const pageData = pagination(page, pageSize, list)
  return {
    code: 0,
    list: pageData,
    message,
    total: 60,
    type: 'success'
  }
}

export function resultError(message = 'Request failed', { code = -1, data = null } = {}) {
  return {
    code,
    data,
    message,
    type: 'error'
  }
}

export function pagination(pageNo, pageSize, array) {
  const offset = (pageNo - 1) * Number(pageSize)
  const ret =
    offset + Number(pageSize) >= array.length
      ? array.slice(offset, array.length)
      : array.slice(offset, offset + Number(pageSize))
  return ret
}
